import { Injectable } from '@angular/core';
import { FitApiClientService, FitList } from '@shared/fit-api-client.service';
import { unwrapAdminListItems } from '@shared/admin-list-response.util';
import { GalleryItem } from '@app/gallery/gallery.service';

interface MuscleGroup {
    id: number;
    name: string;
    order: number;
}

interface MuscleGroupById extends MuscleGroup {
    image: GalleryItem;
}

interface MuscleGroupRequest {
    name: string;
    image_id: number;
    order: number;
}

export { FitList, MuscleGroup, MuscleGroupById, MuscleGroupRequest };

@Injectable({ providedIn: 'root' })

export class MuscleGroupService {
    constructor(private fitApi: FitApiClientService) { }

    public search(query: string, page: number) {
        return this.fitApi.get<FitList<MuscleGroup>>('/admin/muscle-group', {
            search: query,
            page: page.toString()
        });
    }

    public all() {
        return this.fitApi.get<Record<string, unknown>>('/admin/muscle-group/list').then(({ data, error }) => ({
            data: unwrapAdminListItems<MuscleGroup>(data, ['muscle_groups']),
            error,
        }));
    }
    
    public get(id: number) {
        return this.fitApi.get<MuscleGroupById>('/admin/muscle-group/' + id);
    }

    public create(muscleGroup: MuscleGroupRequest) {
        return this.fitApi.put<MuscleGroupById>('/admin/muscle-group/0', muscleGroup);
    }

    public update(muscleGroupId: number, muscleGroup: MuscleGroupRequest) {
        return this.fitApi.put<MuscleGroupById>('/admin/muscle-group/' + muscleGroupId, muscleGroup);
    }

    public delete(id: number) {
        return this.fitApi.delete<any>('/admin/muscle-group/' + id);
    }

    public mapToMuscleGroupRequest(muscleGroup: MuscleGroup): MuscleGroupRequest {
        return {
            name: muscleGroup.name,
            image_id: null,
            order: muscleGroup.order ?? null,
        };
    }
}
